import { render, staticRenderFns } from "./ButtonsAndSubscriptionComponent.vue?vue&type=template&id=bb979792&scoped=true&"
import script from "./ButtonsAndSubscriptionComponent.vue?vue&type=script&lang=js&"
export * from "./ButtonsAndSubscriptionComponent.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsAndSubscriptionComponent.vue?vue&type=style&index=0&id=bb979792&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb979792",
  null
  
)

export default component.exports